import { useState } from 'react';
import { Award, GitCommit } from 'tabler-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import {
	// setIsVerifyType,
	// setIsSectionType,
	setSelectedFilter
	// setHasFilter
} from 'Actions';
import { FilterBox, CheckboxItem } from 'Elements';
import styles from 'partials/checkbox.module.scss';

export const FilterBoxStoryType = ({ onChange }) => {
	const dispatch = useDispatch();
	const filters = useSelector((state) => state.fltr);
	const [types] = useState({
		list: [
			{
				id: 0,
				title: 'روایت های دنباله دار',
				type: 'is_section',
				icon: GitCommit,
				value: 0
			},
			{
				id: 1,
				title: 'روایت های مرجع',
				type: 'is_verify',
				icon: Award,
				value: 0
			}
		],
		is_section: 0,
		is_verify: 0
	});

	const handleFilterChange = (type, isChecked) => {
		const selected_type = types;
		selected_type[type] = isChecked ? 1 : 0;

		if (type === 'is_section') {
			dispatch(
				setSelectedFilter({
					name: 'is_section',
					value: selected_type.is_section
				})
			);
			// dispatch(setIsSectionType(selected_type.is_section));
		}
		if (type === 'is_verify') {
			dispatch(
				setSelectedFilter({
					name: 'is_verify',
					value: selected_type.is_verify
				})
			);
			// dispatch(setIsVerifyType(selected_type.is_verify));
		}
		onChange?.();
	};

	return (
		<FilterBox title="نوع روایت">
			{types.list.map((elem) => {
				return (
					<CheckboxItem
						key={elem.id}
						id={`check_${elem.type}_${elem.id}`}
						item={elem.type}
						label={elem.title}
						isChecked={filters.selected_filter[elem.type]}
						icon={elem.icon}
						iconClass={
							elem.type === 'is_section' && styles.iconRotate
						}
						onChange={handleFilterChange}
					/>
				);
			})}
			{/* <Checkbox
				id="is_section"
				item="is_section"
				label="روایت های دنباله دار"
				isChecked={filters.selected_filter.is_section}
				icon={GitCommit}
				iconClass={styles.iconRotate}
				onChange={handleFilterChange}
			/>
			<Checkbox
				id="is_verify"
				item="is_verify"
				label="روایت های مرجع"
				isChecked={filters.selected_filter.is_verify}
				icon={Award}
				onChange={handleFilterChange}
			/> */}
		</FilterBox>
	);
};
